import i18n from 'i18next';
import i18nBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    fallbackLng: 'fi',
    interpolation: {
      escapeValue: false, // react already protects from xss
    },
    lng: 'fi',
    whitelist: ['en', 'fi'],
  });

export default i18n;
